import { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import axios from 'axios';
import { Badge } from '@/components/ui/badge';
import { Button } from '@/components/ui/button';
import { Skeleton } from '@/components/ui/skeleton';
import { ArrowLeft, Calendar, Sparkles } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function NewsDettaglio() {
  const { id } = useParams();
  const [article, setArticle] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios.get(`${API}/news/${id}`)
      .then(r => setArticle(r.data))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, [id]);

  if (loading) return (
    <div className="max-w-4xl mx-auto px-4 py-20">
      <Skeleton className="h-8 w-64 mb-4" />
      <Skeleton className="h-4 w-full mb-2" />
      <Skeleton className="h-4 w-3/4 mb-6" />
      <Skeleton className="h-64 rounded-xl" />
    </div>
  );

  if (!article) return (
    <div className="max-w-4xl mx-auto px-4 py-20 text-center">
      <p className="text-lg text-muted-foreground mb-4">Articolo non trovato</p>
      <Link to="/news"><Button variant="outline"><ArrowLeft size={16} className="mr-2" /> Torna alle news</Button></Link>
    </div>
  );

  return (
    <div>
      <section className="hero-wash py-10 sm:py-16">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <Link to="/news" className="inline-flex items-center text-sm text-[#238A92] hover:underline mb-4">
            <ArrowLeft size={16} className="mr-1" /> Tutte le news
          </Link>
          <div className="flex items-center gap-2 mb-3">
            {article.topic_nome && <Badge className="bg-[hsl(var(--accent))] text-[hsl(var(--accent-foreground))]">{article.topic_nome}</Badge>}
            {article.generated_by_ai && <Badge variant="secondary" className="text-xs"><Sparkles size={10} className="mr-1" /> Generato con AI</Badge>}
          </div>
          <h1 className="text-3xl sm:text-4xl font-bold text-[#1F2A37] mb-4" style={{fontFamily:'Space Grotesk'}}>{article.titolo}</h1>
          {article.sommario && <p className="text-lg text-muted-foreground leading-relaxed">{article.sommario}</p>}
          <div className="flex items-center gap-2 mt-4 text-sm text-muted-foreground">
            <Calendar size={14} />
            {article.published_at ? new Date(article.published_at).toLocaleDateString('it-IT', {day:'numeric', month:'long', year:'numeric'}) : new Date(article.created_at).toLocaleDateString('it-IT', {day:'numeric', month:'long', year:'numeric'})}
          </div>
        </div>
      </section>

      <section className="py-10 sm:py-16">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          {article.immagine_url && (
            <div className="rounded-2xl overflow-hidden shadow-[var(--shadow-md)] mb-8">
              <img src={article.immagine_url} alt={article.titolo} className="w-full max-h-[500px] object-cover" />
            </div>
          )}
          <article className="prose max-w-none">
            {article.contenuto.split('\n').map((p, i) => (
              p.trim() ? <p key={`p-${i}-${p.slice(0,15)}`} className="text-muted-foreground leading-relaxed mb-4 text-base">{p}</p> : null
            ))}
          </article>
          <div className="mt-10 pt-6 border-t flex items-center justify-between">
            <Link to="/news">
              <Button variant="outline"><ArrowLeft size={16} className="mr-2" /> Altre news</Button>
            </Link>
            <Link to="/prenota">
              <Button className="bg-[#238A92] hover:bg-[#0F5E66] text-white">Prenota un Appuntamento</Button>
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
}
